import { render, staticRenderFns } from "./IconErrorLamp.vue?vue&type=template&id=da332f0e&"
import script from "./IconErrorLamp.vue?vue&type=script&lang=js&"
export * from "./IconErrorLamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports